import Vue from 'vue'
import VueCharts from 'vue-chartjs'
// import {Bar, Line} from 'vue-chartjs'

Vue.use(VueCharts)
